<template>
  <div class="flex flex-row items-center justify-center">
    <img id="img-404" src="/img/404.svg" alt="DesignMorphine logo" />
  </div>
</template>

<script>
export default {
  name: 'not-found',
};
</script>

<style lang="scss" scoped>
#img-404 {
  width: 75%;
  opacity: 0.3;
}
</style>
